import { createFileRoute } from '@tanstack/react-router'
import { Users } from 'lucide-react'

import { PlaceholderPage } from '@/components/placeholder-page'

export const Route = createFileRoute('/users')({
  component: () => (
    <PlaceholderPage
      icon={Users}
      title="Users"
      description="Invite teammates and manage roles and access to the orchestration platform here."
    />
  ),
})
